module.exports = __webpack_public_path__ + "img/skull_narrow_summary.983c26e1.png";